export default {

  // Login
  ADMIN_LOGIN: 'ADMIN_LOGIN',
  ADMIN_LOGIN_SUCCESS: 'ADMIN_LOGIN_SUCCESS',
  ADMIN_LOGIN_ERROR: 'ADMIN_LOGIN_ERROR',

  // Uers
  GET_USERS: 'GET_USERS',
  GET_USERS_SUCCESS: 'GET_USERS_SUCCESS',
  GET_USERS_ERROR: 'GET_USERS_ERROR',
  EDIT_USER: 'EDIT_USERS',
  EDIT_USER_SUCCESS: 'EDIT_USER_SUCCESS',
  EDIT_USER_ERROR: 'EDIT_USER_ERROR',
  DELETE_USER: 'DELETE_USER',
  DELETE_USER_SUCCESS: 'DELETE_USER_SUCCESS',
  DELETE_USER_ERROR: 'DELETE_USER_ERROR',

  // Appoinments
  GET_APPOITMENTS: 'GET_APPOITMENTS',
  GET_APPOITMENTS_SUCCESS: 'GET_APPOITMENTS_SUCCESS',
  GET_APPOITMENTS_ERROR: 'GET_APPOITMENTS_ERROR',
  DELETE_APPOITMENT: 'DELETE_APPOITMENT',
  DELETE_APPOITMENT_SUCCESS: 'DELETE_APPOITMENT_SUCCESS',
  DELETE_APPOITMENT_ERROR: 'DELETE_APPOITMENT_ERROR',

  // Partners
  GET_PARTNERS: 'GET_PARTNERS',
  GET_PARTNERS_SUCCESS: 'GET_PARTNERS_SUCCESS',
  GET_PARTNERS_ERROR: 'GET_PARTNERS_ERROR',
  ADD_PARTNER: 'ADD_PARTNER',
  ADD_PARTNER_SUCCESS: 'ADD_PARTNER_SUCCESS',
  ADD_PARTNER_ERROR: 'ADD_PARTNER_ERROR',
  EDIT_PARTNER: 'EDIT_PARTNER',
  EDIT_PARTNER_SUCCESS: 'EDIT_PARTNER_SUCCESS',
  EDIT_PARTNER_ERROR: 'EDIT_PARTNER_ERROR',
  DELETE_PARTNER: 'DELETE_PARTNER',
  DELETE_PARTNER_SUCCESS: 'DELETE_PARTNER_SUCCESS',
  DELETE_PARTNER_ERROR: 'DELETE_PARTNER_ERROR',

  // Partner accounts
  GET_PARTNER_ACCCOUNT: 'GET_PARTNER_ACCCOUNT',
  GET_PARTNER_ACCCOU_SUCCESS: 'GET_PARTNER_ACCCOU_SUCCESS',
  GET_PARTNER_ACCCOUNT_ERROR: 'GET_PARTNER_ACCCOUNT_ERROR',
  ADD_PARTNER_ACCOUNT: 'ADD_PARTNER_ACCOUNT',
  ADD_PARTNER_ACCOUNT_SUCCESS: 'ADD_PARTNER_ACCOUNT_SUCCESS',
  ADD_PARTNER_ACCOUNT_ERROR: 'ADD_PARTNER_ACCOUNT_ERROR',
  EDIT_PARTNER_ACCOUNT: 'EDIT_PARTNER_ACCOUNT',
  EDIT_PARTNER_ACCOUNT_SUCCESS: 'EDIT_PARTNER_ACCOUNT_SUCCESS',
  EDIT_PARTNER_ACCOUNT_ERROR: 'EDIT_PARTNER_ACCOUNT_ERROR',
  DELETE_PARTNER_ACCOUNT: 'DELETE_PARTNER_ACCOUNT',
  DELETE_PARTNER_ACCOUNT_SUCCESS: 'DELETE_PARTNER_ACCOUNT_SUCCESS',
  DELETE_PARTNER_ACCOUNT_ERROR: 'DELETE_PARTNER_ACCOUNT_ERROR',

  // Products
  GET_PRODUCTS: 'GET_PRODUCTS',
  GET_PRODUCTS_SUCCESS: 'GET_PRODUCTS_SUCCESS',
  GET_PRODUCTS_ERROR: 'GET_PRODUCTS_ERROR',
  ADD_PRODUCT: 'ADD_PRODUCT',
  ADD_PRODUCT_SUCCESS: 'ADD_PRODUCT_SUCCESS',
  ADD_PRODUCT_ERROR: 'ADD_PRODUCT_ERROR',
  DELETE_PRODUCT: 'DELETE_PRODUCT',
  DELETE_PRODUCT_SUCCESS: 'DELETE_PRODUCT_SUCCESS',
  DELETE_PRODUCT_ERROR: 'DELETE_PRODUCT_ERROR',
  EDIT_PRODUCT: 'EDIT_PRODUCT',
  EDIT_PRODUCT_SUCCESS: 'EDIT_PRODUCT_SUCCESS',
  EDIT_PRODUCT_ERROR: 'EDIT_PRODUCT_ERROR',
  
  // Achievements
  GET_ACHIEVEMENTS: 'GET_ACHIEVEMENTS',
  GET_ACHIEVEMENTS_SUCCESS: 'GET_ACHIEVEMENTS_SUCCESS',
  GET_ACHIEVEMENTS_ERROR: 'GET_ACHIEVEMENTS_ERROR',
  ADD_ACHIEVEMENT: 'ADD_ACHIEVEMENT',
  ADD_ACHIEVEMENT_SUCCESS: 'ADD_ACHIEVEMENT_SUCCESS',
  ADD_ACHIEVEMENT_ERROR: 'ADD_ACHIEVEMENT_ERROR',
  EDIT_ACHIEVEMENT: 'EDIT_ACHIEVEMENT',
  EDIT_ACHIEVEMENT_SUCCESS: 'EDIT_ACHIEVEMENT_SUCCESS',
  EDIT_ACHIEVEMENT_ERROR: 'EDIT_ACHIEVEMENT_ERROR',
  DELETE_ACHIEVEMENT: 'DELETE_ACHIEVEMENT',
  DELETE_ACHIEVEMENT_SUCCESS: 'DELETE_ACHIEVEMENT_SUCCESS',
  DELETE_ACHIEVEMENT_ERROR: 'DELETE_ACHIEVEMENT_ERROR',

  // Ads
  GET_ADS: 'GET_ADS',
  GET_ADS_SUCCESS: 'GET_ADS_SUCCESS',
  GET_ADS_ERROR: 'GET_ADS_ERROR',
  ADD_AD: 'ADD_AD',
  ADD_AD_SUCCESS: 'ADD_AD_SUCCESS',
  ADD_AD_ERROR: 'ADD_AD_ERROR',
  EDIT_AD: 'EDIT_AD',
  EDIT_AD_SUCCESS: 'EDIT_AD_SUCCESS',
  EDIT_AD_ERROR: 'EDIT_AD_ERROR',
  DELETE_AD: 'DELETE_AD',
  DELETE_AD_SUCCESS: 'DELETE_AD_SUCCESS',
  DELETE_AD_ERROR: 'DELETE_AD_ERROR',

  // Selected Products
  GET_SELECTED_PRODUCTS: 'GET_SELECTED_PRODUCTS',
  GET_SELECTED_PRODUCTS_SUCCESS: 'GET_SELECTED_PRODUCTS_SUCCESS',
  GET_SELECTED_PRODUCTS_ERROR: 'GET_SELECTED_PRODUCTS_ERROR',
  ADD_SELECTED_PRODUCT: 'ADD_SELECTED_PRODUCT',
  ADD_SELECTED_PRODUCT_SUCCESS: 'ADD_SELECTED_PRODUCT_SUCCESS',
  ADD_SELECTED_PRODUCT_ERROR: 'ADD_SELECTED_PRODUCT_ERROR',
  DELETE_SELECTED_PRODUCT: 'DELETE_SELECTED_PRODUCT',
  DELETE_SELECTED_PRODUCT_SUCCESS: 'DELETE_SELECTED_PRODUCT_SUCCESS',
  DELETE_SELECTED_PRODUCT_ERROR: 'DELETE_SELECTED_PRODUCT_ERROR',
  EDIT_SELECTED_PRODUCT: 'EDIT_SELECTED_PRODUCT',
  EDIT_SELECTED_PRODUCT_SUCCESS: 'EDIT_SELECTED_PRODUCT_SUCCESS',
  EDIT_SELECTED_PRODUCT_ERROR: 'EDIT_SELECTED_PRODUCT_ERROR',

  // Payouts
  GET_PAYOUTS: 'GET_PAYOUTS',
  GET_PAYOUTS_SUCCESS: 'GET_PAYOUTS_SUCCESS',
  GET_PAYOUTS_ERROR: 'GET_PAYOUTS_ERROR',
  DELETE_PAYOUT: 'DELETE_PAYOUT',
  DELETE_PAYOUT_SUCCESS: 'DELETE_PAYOUT_SUCCESS',
  DELETE_PAYOUT_ERROR: 'DELETE_PAYOUT_ERROR',
  APPROVE_PAYOUT: 'APPROVE_PAYOUT',
  APPROVE_PAYOUT_SUCCESS: 'APPROVE_PAYOUT_SUCCESS',
  APPROVE_PAYOUT_ERROR: 'APPROVE_PAYOUT_ERROR',
  REJECT_PAYOUT: 'REJECT_PAYOUT',
  REJECT_PAYOUT_SUCCESS: 'REJECT_PAYOUT_SUCCESS',
  REJECT_PAYOUT_ERROR: 'REJECT_PAYOUT_ERROR',


  //   // // subscribers
  //   // GET_SUBSCRIBERS,
  //   // GET_SUBSCRIBERS_SUCCESS,
  //   // GET_SUBSCRIBERS_ERROR,
  //   // DELETE_SUBSCRIBERS,
  //   // DELETE_SUBSCRIBERS_SUCCESS,
  //   // DELETE_SUBSCRIBERS_ERROR,

  //   // // propdesks
  //   // GET_PROPDESKS,
  //   // GET_PROPDESKS_SUCCESS,
  //   // GET_PROPDESKS_ERROR,
  //   // ADD_PROPDESKS,
  //   // ADD_PROPDESKS_SUCCESS,
  //   // ADD_PROPDESKS_ERROR,
  //   // EDIT_PROPDESKS,
  //   // EDIT_PROPDESKS_SUCCESS,
  //   // EDIT_PROPDESKS_ERROR,
  //   // DELETE_PROPDESKS,
  //   // DELETE_PROPDESKS_SUCCESS,
  //   // DELETE_PROPDESKS_ERROR,

  //   // stock of the month
  //   // GET_STOCK,
  //   // GET_STOCK_SUCCESS,
  //   // GET_STOCK_ERROR,
  //   // ADD_STOCK,
  //   // ADD_STOCK_SUCCESS,
  //   // ADD_STOCK_ERROR,
  //   // EDIT_STOCK,
  //   // EDIT_STOCK_SUCCESS,
  //   // EDIT_STOCK_ERROR,
  //   // DELETE_STOCK,
  //   // DELETE_STOCK_SUCCESS,
  //   // DELETE_STOCK_ERROR

}